module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-faq"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-content"
  }, [_c('div', {
    staticClass: "faq-height"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "tab-content faq-tab-content"
  }, [_c('div', {
    staticClass: "tab-pane active",
    attrs: {
      "role": "tabpanel",
      "id": "tab-starting"
    }
  }, [_c('div', {
    staticClass: "accordion",
    attrs: {
      "id": "accordion-starting"
    }
  }, [_vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "accordion-group"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "accordion-body collapse",
    attrs: {
      "id": "collapse-13"
    }
  }, [_c('div', {
    staticClass: "accordion-inner"
  }, [_vm._v("\n                                    Starting an engraved brick fundraiser can be easy with the right tools. Fund Raisers, Ltd. offers a\n                                    "), _c('router-link', {
    staticClass: "frl-link",
    attrs: {
      "to": "/fundraising-toolkit"
    }
  }, [_vm._v("Free Brick Fundraiser Website")]), _vm._v("\n                                    that allows you to share information about your fundraiser with your donors and collect donor orders and payments.\n                                    We also provide you our Roadmap to Success, designed to guide you step-by-step through your fundraiser!\n                                    You will find instructions on how to manage your Brick Fundraiser Website, tips and tricks for managing your fundraiser, marketing guides and best practices, with so much more!\n                                ")], 1)])]), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8)])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "role": "tabpanel",
      "id": "tab-products"
    }
  }, [_c('div', {
    staticClass: "accordion",
    attrs: {
      "id": "accordion-products"
    }
  }, [_c('div', {
    staticClass: "accordion-group"
  }, [_vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "accordion-body collapse",
    attrs: {
      "id": "collapse-21"
    }
  }, [_c('div', {
    staticClass: "accordion-inner"
  }, [_vm._v("\n                                    Fund Raisers, Ltd. offers a variety of brick and tile material options specifically selected for their industry-leading quality.\n                                    To view our selection, please visit the "), _c('router-link', {
    staticClass: "frl-link",
    attrs: {
      "to": "/product-guide"
    }
  }, [_vm._v("Product Guide")]), _vm._v(" page or contact us.\n                                ")], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "accordion-group"
  }, [_vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "accordion-body collapse",
    attrs: {
      "id": "collapse-22"
    }
  }, [_c('div', {
    staticClass: "accordion-inner"
  }, [_vm._v("\n                                    Fund Raisers, Ltd.'s experienced technicians use a unique, hand-made production process to ensure maximum quality and legibility.\n                                    Each inscription is sandblasted to a depth of 1/8\" to 1/4\" before our proprietary, lab-tested filler material is inserted into the engraved cavities to restore the brick's surface and prevent collection of dirt and debris in the engraved areas.\n                                    "), _c('router-link', {
    staticClass: "frl-link",
    attrs: {
      "to": "/unmatched-quality"
    }
  }, [_vm._v("Click here")]), _vm._v(" for more information about our production process and unmatched quality.\n                                ")], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "accordion-group"
  }, [_vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "accordion-body collapse",
    attrs: {
      "id": "collapse-23"
    }
  }, [_c('div', {
    staticClass: "accordion-inner"
  }, [_vm._v("\n                                    Our proprietary filler is inserted into the engraved areas to restore the material's surface and ensure lasting durability and legibility without collection of dirt or debris in the engravings.\n                                    To learn more about our quality, "), _c('router-link', {
    staticClass: "frl-link",
    attrs: {
      "to": "/unmatched-quality"
    }
  }, [_vm._v("click here")]), _vm._v(".\n                                ")], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "accordion-group"
  }, [_vm._m(12), _vm._v(" "), _c('div', {
    staticClass: "accordion-body collapse",
    attrs: {
      "id": "collapse-24"
    }
  }, [_c('div', {
    staticClass: "accordion-inner"
  }, [_vm._v("\n                                    Fund Raisers, Ltd. has hand-selected materials made by industry-leading manufacturers to ensure that the product you choose will maintain its integrity in any climate.\n                                    Please visit our "), _c('router-link', {
    staticClass: "frl-link",
    attrs: {
      "to": "/portfolio"
    }
  }, [_vm._v("Portfolio")]), _vm._v(" for a list of projects in your region!\n                                ")], 1)])]), _vm._v(" "), _vm._m(13), _vm._v(" "), _vm._m(14)])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "role": "tabpanel",
      "id": "tab-inscriptions"
    }
  }, [_c('div', {
    staticClass: "accordion",
    attrs: {
      "id": "accordion-inscriptions"
    }
  }, [_c('div', {
    staticClass: "accordion-group"
  }, [_vm._m(15), _vm._v(" "), _c('div', {
    staticClass: "accordion-body collapse",
    attrs: {
      "id": "collapse-31"
    }
  }, [_c('div', {
    staticClass: "accordion-inner"
  }, [_vm._v("\n                                    Often people engrave their names, family names, pet names, important dates, or favorite quotes.\n                                    "), _c('a', {
    staticClass: "frl-link pointer",
    on: {
      "click": function($event) {
        _vm.showInscriptionExamples()
      }
    }
  }, [_vm._v("Click here")]), _vm._v(" to view examples of possible engraved inscriptions.\n                                ")])])]), _vm._v(" "), _c('div', {
    staticClass: "accordion-group"
  }, [_vm._m(16), _vm._v(" "), _c('div', {
    staticClass: "accordion-body collapse",
    attrs: {
      "id": "collapse-32"
    }
  }, [_c('div', {
    staticClass: "accordion-inner"
  }, [_vm._v("\n                                    Any letters, numbers, punctuation marks, or symbols found on a standard English keyboard can be featured in an inscription. We also allow a selection of special characters and custom logo options.\n                                    "), _c('router-link', {
    staticClass: "frl-link",
    attrs: {
      "to": "/product-guide"
    }
  }, [_vm._v("Click here")]), _vm._v(" to learn more about our symbol and logo options.\n                                ")], 1)])]), _vm._v(" "), _vm._m(17), _vm._v(" "), _c('div', {
    staticClass: "accordion-group"
  }, [_vm._m(18), _vm._v(" "), _c('div', {
    staticClass: "accordion-body collapse",
    attrs: {
      "id": "collapse-34"
    }
  }, [_c('div', {
    staticClass: "accordion-inner"
  }, [_vm._v("\n                                    The brick or tile size and font option you select will dictate the number of characters available per line.\n                                    "), _c('router-link', {
    staticClass: "frl-link",
    attrs: {
      "to": "/product-guide"
    }
  }, [_vm._v("Click here")]), _vm._v(" to see our available font options to learn more.\n                                ")], 1)])]), _vm._v(" "), _vm._m(19), _vm._v(" "), _vm._m(20)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "jumbo-wrapper faq"
  }, [_c('div', {
    staticClass: "jumbo-main"
  }, [_c('div', {
    staticClass: "jumbo-content"
  }, [_c('p', {
    staticClass: "t15"
  }, [_vm._v("FREQUENTLY ASKED QUESTIONS")]), _vm._v(" "), _c('h2', {
    staticClass: "t42"
  }, [_vm._v("\n                    CONTACT US!\n                    "), _c('br'), _vm._v("\n                    WE HAVE ANSWERS.\n                ")]), _vm._v(" "), _c('p', {
    staticClass: "t20"
  }, [_vm._v("For additional information, contact our helpful representatives.")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "nav nav-tabs faq-nav-tabs",
    attrs: {
      "role": "tablist"
    }
  }, [_c('li', {
    staticClass: "active",
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    attrs: {
      "href": "#tab-starting",
      "aria-controls": "tab-starting",
      "role": "tab",
      "data-toggle": "tab"
    }
  }, [_vm._v("STARTING A PROGRAM")])]), _vm._v(" "), _c('li', {
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    attrs: {
      "href": "#tab-products",
      "aria-controls": "tab-products",
      "role": "tab",
      "data-toggle": "tab"
    }
  }, [_vm._v("PRODUCTS & INSTALLATION")])]), _vm._v(" "), _c('li', {
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    attrs: {
      "href": "#tab-inscriptions",
      "aria-controls": "tab-inscriptions",
      "role": "tab",
      "data-toggle": "tab"
    }
  }, [_vm._v("INSCRIPTIONS")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "accordion-group"
  }, [_c('div', {
    staticClass: "accordion-heading"
  }, [_c('a', {
    staticClass: "accordion-toggle collapsed",
    attrs: {
      "data-toggle": "collapse",
      "href": "#collapse-11"
    }
  }, [_vm._v("WHY SHOULD I LAUNCH AN ENGRAVED BRICK FUNDRAISER?")])]), _vm._v(" "), _c('div', {
    staticClass: "accordion-body collapse",
    attrs: {
      "id": "collapse-11"
    }
  }, [_c('div', {
    staticClass: "accordion-inner"
  }, [_vm._v("\n                                    Engraved bricks have many great benefits! Not only are they a substantial source of revenue, but they also engage your community by providing a personal and lasting connection to your project. Engraved bricks can be a great way to enhance your facility's aesthetics while creating a gathering space that can be enjoyed for generations.\n                                ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "accordion-group"
  }, [_c('div', {
    staticClass: "accordion-heading"
  }, [_c('a', {
    staticClass: "accordion-toggle collapsed",
    attrs: {
      "data-toggle": "collapse",
      "href": "#collapse-12"
    }
  }, [_vm._v("Why should I choose Fund Raisers, Ltd.?")])]), _vm._v(" "), _c('div', {
    staticClass: "accordion-body collapse",
    attrs: {
      "id": "collapse-12"
    }
  }, [_c('div', {
    staticClass: "accordion-inner"
  }, [_vm._v("\n                                    With over 30 years of experience, Fund Raisers, Ltd. continues to be the leader of the brick engraving industry. We have worked with over 100 professional sports and collegiate organizations, along with thousands of community organizations in all 50 states. Our bricks go through a handmade production process to ensure maximum quality and durability. Our propietary engraving process has been designed to withstand the test of time.\n                                ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "accordion-heading"
  }, [_c('a', {
    staticClass: "accordion-toggle collapsed",
    attrs: {
      "data-toggle": "collapse",
      "href": "#collapse-13"
    }
  }, [_vm._v("How do I start a program?")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "accordion-group"
  }, [_c('div', {
    staticClass: "accordion-heading"
  }, [_c('a', {
    staticClass: "accordion-toggle collapsed",
    attrs: {
      "data-toggle": "collapse",
      "href": "#collapse-14"
    }
  }, [_vm._v("How do I price the bricks for sale?")])]), _vm._v(" "), _c('div', {
    staticClass: "accordion-body collapse",
    attrs: {
      "id": "collapse-14"
    }
  }, [_c('div', {
    staticClass: "accordion-inner"
  }, [_vm._v("\n                                    There is no right or wrong answer for how you price your bricks. Although, it will be important to keep in mind the cost for the bricks and ensure that you balance profit with accessibility so that as many people as possible can participate. Consider your audience demographics, the nature of your fundraiser, and how much space you have for engraved bricks (thus how many bricks you are able to sell). These factors will also help determine your price point.\n                                ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "accordion-group"
  }, [_c('div', {
    staticClass: "accordion-heading"
  }, [_c('a', {
    staticClass: "accordion-toggle collapsed",
    attrs: {
      "data-toggle": "collapse",
      "href": "#collapse-15"
    }
  }, [_vm._v("How do I market the fundraising project?")])]), _vm._v(" "), _c('div', {
    staticClass: "accordion-body collapse",
    attrs: {
      "id": "collapse-15"
    }
  }, [_c('div', {
    staticClass: "accordion-inner"
  }, [_vm._v("\n                                    Marketing is key to a successful campaign. It will be important to appoint a team who can help design flyers, order forms, email blasts and create social media posts. Click \"Request More Information\" at the bottom of this page to receive our Roadmap to Success, which outlines templates, tips, and tricks!\n                                ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "accordion-group"
  }, [_c('div', {
    staticClass: "accordion-heading"
  }, [_c('a', {
    staticClass: "accordion-toggle collapsed",
    attrs: {
      "data-toggle": "collapse",
      "href": "#collapse-16"
    }
  }, [_vm._v("Can I get marketing brick for display?")])]), _vm._v(" "), _c('div', {
    staticClass: "accordion-body collapse",
    attrs: {
      "id": "collapse-16"
    }
  }, [_c('div', {
    staticClass: "accordion-inner"
  }, [_vm._v("\n                                    We believe publicizing examples of your end product is key to help your donor relate to your project and visualize their purchase. Fund Raisers, Ltd. offers a free marketing brick to display in a lobby, front office, at a community event or other efforts to promote your fundraiser. You may order your marketing brick by contacting our customer service team.\n                                ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "accordion-group"
  }, [_c('div', {
    staticClass: "accordion-heading"
  }, [_c('a', {
    staticClass: "accordion-toggle collapsed",
    attrs: {
      "data-toggle": "collapse",
      "href": "#collapse-17"
    }
  }, [_vm._v("Who are my donors?")])]), _vm._v(" "), _c('div', {
    staticClass: "accordion-body collapse",
    attrs: {
      "id": "collapse-17"
    }
  }, [_c('div', {
    staticClass: "accordion-inner"
  }, [_vm._v("\n                                    Donors can be family, friends, congregation, coworkers, students, staff, etc. Remember to access any mail or email lists you might have to get word out and make sure you enlist help from members of your community.\n                                ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "accordion-heading"
  }, [_c('a', {
    staticClass: "accordion-toggle collapsed",
    attrs: {
      "data-toggle": "collapse",
      "href": "#collapse-21"
    }
  }, [_vm._v("What products does Fund Raisers, Ltd. offer?")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "accordion-heading"
  }, [_c('a', {
    staticClass: "accordion-toggle collapsed",
    attrs: {
      "data-toggle": "collapse",
      "href": "#collapse-22"
    }
  }, [_vm._v("How are bricks engraved?")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "accordion-heading"
  }, [_c('a', {
    staticClass: "accordion-toggle collapsed",
    attrs: {
      "data-toggle": "collapse",
      "href": "#collapse-23"
    }
  }, [_vm._v("Are the engraved letters painted or filled?")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "accordion-heading"
  }, [_c('a', {
    staticClass: "accordion-toggle collapsed",
    attrs: {
      "data-toggle": "collapse",
      "href": "#collapse-24"
    }
  }, [_vm._v("WHICH PRODUCT IS BEST SUITED FOR MY CLIMATE?")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "accordion-group"
  }, [_c('div', {
    staticClass: "accordion-heading"
  }, [_c('a', {
    staticClass: "accordion-toggle collapsed",
    attrs: {
      "data-toggle": "collapse",
      "href": "#collapse-25"
    }
  }, [_vm._v("WHAT MATERIALS ARE USED FOR THE KEEPSAKE REPLICAS?")])]), _vm._v(" "), _c('div', {
    staticClass: "accordion-body collapse",
    attrs: {
      "id": "collapse-25"
    }
  }, [_c('div', {
    staticClass: "accordion-inner"
  }, [_c('p', [_vm._v("4x8 and 8x8 keepsake replicas are made with the same inscription and material as the installed brick/tile.")]), _vm._v(" "), _c('p', [_vm._v("12x12 keepsake replicas will feature the same inscription as your installed brick/tile, but engraved on a smooth-face black granite tile affixed to a black frame.")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "accordion-group"
  }, [_c('div', {
    staticClass: "accordion-heading"
  }, [_c('a', {
    staticClass: "accordion-toggle collapsed",
    attrs: {
      "data-toggle": "collapse",
      "href": "#collapse-26"
    }
  }, [_vm._v("DOES FUND RAISERS, LTD. PROVIDE BRICK OR TILE INSTALLATION SERVICES?")])]), _vm._v(" "), _c('div', {
    staticClass: "accordion-body collapse",
    attrs: {
      "id": "collapse-26"
    }
  }, [_c('div', {
    staticClass: "accordion-inner"
  }, [_vm._v("\n                                    Fund Raisers, Ltd. does not provide installation services and recommends working with an experienced installer for your project.\n                                ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "accordion-heading"
  }, [_c('a', {
    staticClass: "accordion-toggle collapsed",
    attrs: {
      "data-toggle": "collapse",
      "href": "#collapse-31"
    }
  }, [_vm._v("What are some examples of inscriptions?")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "accordion-heading"
  }, [_c('a', {
    staticClass: "accordion-toggle collapsed",
    attrs: {
      "data-toggle": "collapse",
      "href": "#collapse-32"
    }
  }, [_vm._v("WHAT CHARACTERS, LOGOS, OR SYMBOLS CAN BE ENGRAVED?")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "accordion-group"
  }, [_c('div', {
    staticClass: "accordion-heading"
  }, [_c('a', {
    staticClass: "accordion-toggle collapsed",
    attrs: {
      "data-toggle": "collapse",
      "href": "#collapse-33"
    }
  }, [_vm._v("IS THE ENGRAVED MESSAGE AUTOMATICALLY CENTERED?")])]), _vm._v(" "), _c('div', {
    staticClass: "accordion-body collapse",
    attrs: {
      "id": "collapse-33"
    }
  }, [_c('div', {
    staticClass: "accordion-inner"
  }, [_vm._v("\n                                    Yes, messages for all brick and tile options will be centered.\n                                ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "accordion-heading"
  }, [_c('a', {
    staticClass: "accordion-toggle collapsed",
    attrs: {
      "data-toggle": "collapse",
      "href": "#collapse-34"
    }
  }, [_vm._v("HOW MANY CHARACTERS FIT ON EACH LINE OF TEXT?")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "accordion-group"
  }, [_c('div', {
    staticClass: "accordion-heading"
  }, [_c('a', {
    staticClass: "accordion-toggle collapsed",
    attrs: {
      "data-toggle": "collapse",
      "href": "#collapse-36"
    }
  }, [_vm._v("HOW MANY LINES OF TEXT CAN BE ENGRAVED?")])]), _vm._v(" "), _c('div', {
    staticClass: "accordion-body collapse",
    attrs: {
      "id": "collapse-36"
    }
  }, [_c('div', {
    staticClass: "accordion-inner"
  }, [_c('p', [_vm._v("4” x 8” bricks or tiles can be engraved with 1-3 lines of text.")]), _vm._v(" "), _c('p', [_vm._v("8” x 8” bricks or tiles can be engraved with 1-6 lines of text.")]), _vm._v(" "), _c('p', [_vm._v("12” x 12” bricks or tiles can be engraved with 1-10 lines of text.")]), _vm._v(" "), _c('p', [_vm._v("*Lines may vary depending on use of logos and symbols.")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "accordion-group"
  }, [_c('div', {
    staticClass: "accordion-heading"
  }, [_c('a', {
    staticClass: "accordion-toggle collapsed",
    attrs: {
      "data-toggle": "collapse",
      "href": "#collapse-37"
    }
  }, [_vm._v("Who approves the inscriptions content?")])]), _vm._v(" "), _c('div', {
    staticClass: "accordion-body collapse",
    attrs: {
      "id": "collapse-37"
    }
  }, [_c('div', {
    staticClass: "accordion-inner"
  }, [_vm._v("\n                                    Our Order Management Tool allows you to conveniently review each inscription for grammatical and spelling accuracy, appropriateness, and format prior to sending your order to Fund Raisers, Ltd. for engraving.\n                                ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-50b98ac5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Faq.vue
// module id = L2VQ
// module chunks = 1